export const compareTwoStrings = (firstString: string, secondString: string) => (
  firstString !== '' && firstString === secondString
);
